export default __webpack_public_path__ + "static/media/checked.b8ecf6f9.svg";